"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContainer = exports.StyledCancelOrderButton = exports.CancelOrderButton = exports.StyledDetailRow = exports.StyledDetailRowChildren = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var twap_1 = require("@orbs-network/twap");
var base_1 = require("../../components/base");
var context_1 = require("../../context");
var hooks_1 = require("../../hooks");
var store_1 = require("../../store");
var styles_1 = require("../../styles");
var OrderExpanded = function (_a) {
    var _b, _c, _d;
    var order = _a.order;
    var translations = (0, context_1.useTwapContext)().translations;
    var minimumDelayMinutes = (0, store_1.useTwapStore)(function (state) { return state.getMinimumDelayMinutes(); });
    var totalChunks = (0, hooks_1.useFormatNumber)({ value: order.ui.totalChunks });
    var srcChunkAmountUsdUi = (0, hooks_1.useFormatNumber)({ value: order.ui.srcChunkAmountUsdUi });
    var srcChunkAmountUsdUiTooltip = (0, hooks_1.useFormatNumber)({ value: order.ui.srcChunkAmountUsdUi, decimalScale: 18 });
    var srcChunkAmountUi = (0, hooks_1.useFormatNumber)({ value: order.ui.srcChunkAmountUi });
    var srcChunkAmountUiTootlip = (0, hooks_1.useFormatNumber)({ value: order.ui.srcChunkAmountUi, decimalScale: 18 });
    var dstMinAmountOutUi = (0, hooks_1.useFormatNumber)({ value: order.ui.dstMinAmountOutUi });
    var dstMinAmountOutUsdUi = (0, hooks_1.useFormatNumber)({ value: order.ui.dstMinAmountOutUsdUi });
    var dstMinAmountOutUsdUiTooltip = (0, hooks_1.useFormatNumber)({ value: order.ui.dstMinAmountOutUsdUi, decimalScale: 18 });
    return ((0, jsx_runtime_1.jsx)(exports.StyledContainer, __assign({ className: "twap-order-expanded" }, { children: (0, jsx_runtime_1.jsxs)(styles_1.StyledColumnFlex, __assign({ gap: 0 }, { children: [order.ui.srcToken && order.ui.dstToken && (0, jsx_runtime_1.jsx)(OrderPrice, { order: order }), (0, jsx_runtime_1.jsxs)(styles_1.StyledColumnFlex, __assign({ className: "twap-extended-order-info" }, { children: [(0, jsx_runtime_1.jsx)(Row, __assign({ label: "".concat(translations.totalTrades), tooltip: translations.totalTradesTooltip }, { children: totalChunks })), (0, jsx_runtime_1.jsxs)(Row, __assign({ label: "".concat(translations.tradeSize), tooltip: translations.tradeSizeTooltip }, { children: [(0, jsx_runtime_1.jsx)(base_1.TokenLogo, { logo: order.ui.srcToken.logoUrl }), (0, jsx_runtime_1.jsxs)(base_1.Tooltip, __assign({ text: "".concat(srcChunkAmountUiTootlip, " ").concat(order.ui.srcToken.symbol) }, { children: [srcChunkAmountUi, " ", (_b = order.ui.srcToken) === null || _b === void 0 ? void 0 : _b.symbol] })), (0, jsx_runtime_1.jsxs)(base_1.Tooltip, __assign({ text: "$ ".concat(srcChunkAmountUsdUiTooltip) }, { children: [" \u2248 $ ", srcChunkAmountUsdUi] }))] })), order.ui.isMarketOrder ? ((0, jsx_runtime_1.jsxs)(Row, __assign({ label: "".concat(translations.minReceivedPerTrade), tooltip: translations.confirmationMinDstAmountTootipMarket }, { children: [(0, jsx_runtime_1.jsx)(base_1.TokenLogo, { logo: order.ui.dstToken.logoUrl }), translations.none, " ", (_c = order.ui.dstToken) === null || _c === void 0 ? void 0 : _c.symbol] }))) : ((0, jsx_runtime_1.jsxs)(Row, __assign({ label: "".concat(translations.minReceivedPerTrade), tooltip: translations.confirmationMinDstAmountTootipLimit }, { children: [(0, jsx_runtime_1.jsx)(base_1.TokenLogo, { logo: order.ui.dstToken.logoUrl }), dstMinAmountOutUi, (_d = order.ui.dstToken) === null || _d === void 0 ? void 0 : _d.symbol, " \u2248 $ ", (0, jsx_runtime_1.jsx)(base_1.Tooltip, __assign({ text: dstMinAmountOutUsdUiTooltip }, { children: dstMinAmountOutUsdUi }))] }))), (0, jsx_runtime_1.jsx)(Row, __assign({ label: "".concat(translations.tradeInterval), tooltip: translations.tradeIntervalTootlip.replace("{{minutes}}", minimumDelayMinutes.toString()) }, { children: (0, store_1.fillDelayText)(order.ui.fillDelay, translations) })), (0, jsx_runtime_1.jsx)(Row, __assign({ label: "".concat(translations.deadline), tooltip: translations.maxDurationTooltip }, { children: order.ui.deadlineUi }))] })), order.ui.status === twap_1.Status.Open && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "twap-order-expanded-cancel-wraper", style: { marginLeft: "auto", marginRight: "auto" } }, { children: (0, jsx_runtime_1.jsx)(exports.CancelOrderButton, { orderId: order.order.id }) })))] })) })));
};
exports.default = OrderExpanded;
var Row = function (_a) {
    var label = _a.label, tooltip = _a.tooltip, children = _a.children;
    return ((0, jsx_runtime_1.jsxs)(exports.StyledDetailRow, __assign({ className: "twap-order-expanded-row" }, { children: [(0, jsx_runtime_1.jsx)(base_1.Label, __assign({ tooltipText: tooltip }, { children: label })), (0, jsx_runtime_1.jsx)(exports.StyledDetailRowChildren, __assign({ className: "twap-order-expanded-right" }, { children: children }))] })));
};
exports.StyledDetailRowChildren = (0, material_1.styled)(styles_1.StyledRowFlex)({
    width: "fit-content",
    gap: 5,
    fontWeight: 300,
    fontSize: 13,
    "& *": {
        fontWeight: "inherit",
        fontSize: "inherit",
    },
    "& .twap-token-logo": {
        width: 21,
        height: 21,
    },
});
exports.StyledDetailRow = (0, material_1.styled)(styles_1.StyledRowFlex)({
    justifyContent: "space-between",
    "& .twap-label": {
        fontWeight: 400,
        fontSize: 14,
        "& p": {
            whiteSpace: "unset",
        },
    },
    "& .text": {
        fontWeight: 300,
    },
    "@media(max-width: 500px)": {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5,
    },
});
var OrderPrice = function (_a) {
    var order = _a.order;
    var _b = (0, hooks_1.useHistoryPrice)(order), leftToken = _b.leftToken, rightToken = _b.rightToken, priceUi = _b.priceUi, toggleInverted = _b.toggleInverted;
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsxs)(StyledMarketPrice, __assign({ justifyContent: "space-between", className: "twap-market-price-section" }, { children: [(0, jsx_runtime_1.jsx)(base_1.Label, { children: order.ui.isMarketOrder ? translations.marketPrice : translations.limitPrice }), (0, jsx_runtime_1.jsx)(base_1.TokenPriceCompare, { leftToken: leftToken, rightToken: rightToken, price: priceUi, toggleInverted: toggleInverted })] })));
};
var CancelOrderButton = function (_a) {
    var orderId = _a.orderId, _b = _a.className, className = _b === void 0 ? "" : _b;
    var _c = (0, hooks_1.useCancelOrder)(), isLoading = _c.isLoading, mutate = _c.mutate;
    var translations = (0, context_1.useTwapContext)().translations;
    return ((0, jsx_runtime_1.jsx)(exports.StyledCancelOrderButton, __assign({ loading: isLoading, onClick: function (e) {
            e.stopPropagation();
            mutate(orderId);
        }, className: "".concat(className, " twap-cancel-order") }, { children: translations.cancelOrder })));
};
exports.CancelOrderButton = CancelOrderButton;
var StyledMarketPrice = (0, material_1.styled)(styles_1.StyledRowFlex)({
    "@media(max-width: 500px)": {
        flexDirection: "column",
        alignItems: "flex-start",
        gap: 5,
    },
});
exports.StyledCancelOrderButton = (0, material_1.styled)(base_1.Button)({
    background: "transparent",
    border: "unset",
    width: "fit-content",
    marginTop: 30,
    fontSize: 15,
    fontFamily: "inherit",
    marginLeft: "auto",
    marginRight: "auto",
    fontWeight: 300,
    marginBottom: 20,
});
exports.StyledContainer = (0, material_1.styled)(styles_1.StyledColumnFlex)({
    width: "100%",
    gap: 15,
    paddingTop: 10,
    color: "#D1D5DB",
    "& *": {
        color: "inherit",
    },
});
